// import axios from 'axios'

const state = {
  token: null,
  authenticated: false,
  userInfo: {
    roles: []
  }
}

const mutations = {
  setToken (state, token) {
    state.token = token
  },
  resetToken (state) {
    state.token = ''
  },
  setAuthenticated (state, isAuthenticated) {
    state.authenticated = isAuthenticated
  },
  setUserInfo (state, userInfo) {
    state.userInfo.roles = userInfo.roles ? userInfo.roles.slice(0) : []
  }
}

const actions = {
  async login ({ commit }, user) {
    // const endpoint =  '/users/login'
    // const { data } = await axios.post(endpoint, user)
    commit('setToken', user.token)
    commit('setAuthenticated', true)
  },
  // async register ({ commit }, user) {
  //   const endpoint =  '/users/register'
  //   const { data } = await axios.post(endpoint, user)
  //   commit('setToken', data.token)
  // },
  logout ({ commit }) {
    commit('resetToken')
    commit('setAuthenticated', false)
  }
}

const getPayload = ({ token }) => {
  const payload = token.split('.')[1]
  return JSON.parse(atob(payload))
}

const getters = {
  isLoggedIn (state) {
    if (!state.token) return false
    let payload = getPayload(state)
    return payload.exp > (Date.now() / 1000)
  },
  currentUser (state) {
    if (!state.token) return {}
    const { name, email } = getPayload(state)
    return { name, email }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
